import isPassiveEventListenerSupported from './isPassiveEventListenerSupported';
var defaultOptions = {
  /**
   * Indicates that events of this type will be
   * dispatched to the registered listener before being dispatched to
   * any `EventTarget` beneath it in the DOM tree.
   */
  capture: false,

  /**
   * Indicates that the listener will never
   * call `preventDefault()`.
   */
  passive: false
};
/**
 * Removes from the specified target an event listener previously
 * registered. The event listener to be removed is identified using a
 * combination of the event type, the event listener function itself,
 * and various optional options that may affect the matching process
 * @param target An object that implements the `EventTarget` interface.
 * @param type A case-sensitive string representing the event type for
 * which to remove an event listener.
 * @param listener The function of the event handler to remove from
 * the event target.
 * @param options An options object that specifies characteristics
 * about the event listener.
 * @param {boolean} options.capture Indicates that events of this type will be
 * dispatched to the registered listener before being dispatched to
 * any `EventTarget` beneath it in the DOM tree.
 * @param {boolean} options.passive Indicates that the listener will never
 * call `preventDefault()`.
 */

export default function removeEvent(target, type, listener) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultOptions;
  target.removeEventListener(type, listener, isPassiveEventListenerSupported() ? options : options.capture);
}
//# sourceMappingURL=removeEvent.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/blaze-consumer/~/@flowio/browser-helpers/lib/esm/removeEvent.js
// module id = 492
// module chunks = 0 1